import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { useState } from "react";
import { Chip } from "@mui/material";
import { LazyPatient } from "@/dentlab/src/store/Patient/patients.store";
import { usePatientStore } from "@/dentlab/src/store/Patient";
import { ResultCard } from "./SearchResultCard";
import {
	SheetContentType,
	useSheetStore,
} from "@/dentlab/src/store/Sheets/sheet.store";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { formatClientNameForSidebar } from "@/lib/utils/client-utils";

export const PatientResultCard: React.FC<{ lazyPatient: LazyPatient }> = ({
	lazyPatient,
}) => {
	const { getPatient, patientName } = usePatientStore((state) => ({
		getPatient: state.getPatient,
		patientName: state.patientName,
	}));
	const [patient, setPatient] = useState<PatientEntityType | null>(null);
	const { openSheet } = useSheetStore();
	const { clientsLookup } = useCentralStore((state) => ({
		clientsLookup: state.clientsLookup,
	}));
	const client = lazyPatient.client_id ? clientsLookup[lazyPatient.client_id] : null;

	const handleOpenPatientSheet = async () => {
		if (!patient) {
			const fetchedPatient = await getPatient(lazyPatient.patient_id);
			if (fetchedPatient) {
				setPatient(fetchedPatient);
				openSheet(SheetContentType.PATIENT, {
					patient: fetchedPatient,
				});
			}
		} else {
			openSheet(SheetContentType.PATIENT, { patient });
		}
	};

	return (
		<ResultCard onClick={handleOpenPatientSheet}>
			<div className="flex items-center gap-2">
				{client && (
					<Chip
						label={formatClientNameForSidebar(
							client.first_name,
							client.last_name,
							client.company_name,
							client.is_company
						)}
						size="small"
						color="default"
					/>
				)}
				<Chip
					label={lazyPatient?.code ?? ""}
					size="small"
					color="primary"
				/>
				<div className="flex flex-col">
					<div className="text-body-lg">
						{lazyPatient?.title ?? ""} {patientName(lazyPatient)}
					</div>
				</div>
			</div>
		</ResultCard>
	);
};
